module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabBox"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    },
    attrs: {
      "data": _vm.tableData,
      "highlight-current-row": ""
    },
    on: {
      "current-change": _vm.currentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "title",
      "align": "center",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orgName",
      "align": "center",
      "label": "上传机构"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createtime",
      "align": "center",
      "label": "上传时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fileDes",
      "align": "center",
      "label": "描述"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "文件"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1f2d3d",
            "text-decoration": "underline"
          },
          attrs: {
            "href": "javascript:(0)"
          },
          on: {
            "click": function($event) {
              _vm.download(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(scope.row.fileName))])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e87bbdd6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/manage/guidefile/bursttab.vue
// module id = 1284
// module chunks = 2